<template>
<div class="chapter">
<div class="inner_page">
<p class="front"><span class="bold">The Characters in the Tale</span></p>
<p class="noindentpara3"><span class="bold">Chief Detective-Inspector Roderick Alleyn, CID</span></p>
<p class="noindentpara3"><span class="bold">Lady Alleyn,</span> <span class="ital">His mother</span></p>
<p class="noindentpara3"><span class="bold">Sarah Alleyn,</span> <span class="ital">His débutante niece</span></p>
<p class="noindentpara3"><span class="bold">Miss Violet Harris,</span> <span class="ital">Secretary to Lady Carrados</span></p>
<p class="noindentpara3"><span class="bold">Lady Evelyn Carrados,</span> <span class="ital">A London hostess</span></p>
<p class="noindentpara3"><span class="bold">Bridget O’Brien,</span> <span class="ital">Her daughter</span></p>
<p class="noindentpara3"><span class="bold">Sir Herbert Carrados,</span> <span class="ital">Her husband</span></p>
<p class="noindentpara3"><span class="bold">Lord Robert Gospell (‘Bunchy’),</span> <span class="ital">A relic of Victorian days</span></p>
<p class="noindentpara3"><span class="bold">Sir Daniel Davidson,</span> <span class="ital">A fashionable London physcian</span></p>
<p class="noindentpara3"><span class="bold">Agatha Troy, RA,</span> <span class="ital">A painter</span></p>
<p class="noindentpara3"><span class="bold">Lady Mildred Potter,</span> <span class="ital">Lord Robert’s widowed sister</span></p>
<p class="noindentpara3"><span class="bold">Donald Potter,</span> <span class="ital">Her son, a medical student</span></p>
<p class="noindentpara3"><span class="bold">Mrs Halcut-Hackett,</span> <span class="ital">A social climber</span></p>
<p class="noindentpara3"><span class="bold">General Halcut-Hackett,</span> <span class="ital">Her husband</span></p>
<p class="noindentpara3"><span class="bold">Miss Rose Birnbaum,</span> <span class="ital">Her protégée</span></p>
<p class="noindentpara3"><span class="bold">Captain Maurice Withers (‘Wits’),</span> <span class="ital">A man about town</span></p>
<p class="noindentpara3"><span class="bold">Colombo Dimitri,</span> <span class="ital">A fashionable caterer</span></p>
<p class="noindentpara3"><span class="bold">Lucy, Dowager Marchioness of Lorrimer,</span> <span class="ital">Eccentric old lady</span></p>
<p class="noindentpara3"><span class="bold">A Taxi-driver</span></p>
<p class="noindentpara3"><span class="bold">Miss Smith,</span> <span class="ital">A friend of Miss Harris</span></p>
<p class="noindentpara3"><span class="bold">Detective-Inspector Fox, CID</span></p>
<p class="noindentpara3"><span class="bold">Percy Percival,</span> <span class="ital">A young man about town</span></p>
<p class="noindentpara3"><span class="bold">Mr Trelawney-Caper,</span> <span class="ital">His friend</span></p>
<p class="noindentpara3"><span class="bold">James d’Arcy Carewe,</span> <span class="ital">A detective-constable</span></p>
<p class="noindentpara3"><span class="bold">François Dupont,</span> <span class="ital">Dimitri’s servant</span></p>
<p class="noindentpara3"><span class="bold">Mr Cuthbert,</span> <span class="ital">Manager of the Matador</span></p>
<p class="noindentpara3"><span class="bold">Vassily,</span> <span class="ital">Alleyn’s servant</span></p>
<p class="noindentpara3"><span class="bold">The Reverend Walter Harris,</span> <span class="ital">A retired clergyman</span></p>
<p class="noindentpara3"><span class="bold">Mrs Walter Harris,</span> <span class="ital">His wife</span></p>
<p class="noindentpara3"><span class="bold">The Assistant Commissioner</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FrontOther01.vue?654b8ece